<div class="filter_overlay" (click)="overlayClicked()"></div>

<div class="modales" [ngClass]="getClassType()">
	<span *ngIf="showButtonClose" class="cerrar_modales" (click)="overlayClicked()"
		><img src="assets/images/close_modal.png" alt="cerrar"
	/></span>
	<img [src]="getPathImageAlert()" alt="info" />
	<h3>{{ title }}</h3>
	<p [innerHTML]="message"></p>

	<div class="botones_modales" *ngIf="type === 'warn'">
		<a class="button" (click)="clickAcept()">{{ textFirstButton }}</a>
		<a *ngIf="showButtonCancel" class="button boton_cancelar" (click)="clickCancel()">{{ textSecondButton }}</a>
	</div>
</div>
